import { render, staticRenderFns } from "./Hospital.vue?vue&type=template&id=401d3b0e"
import script from "./Hospital.vue?vue&type=script&lang=ts"
export * from "./Hospital.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports